import { useState } from 'react';

export interface UseSuitePageUIStateReturn {
  showOverlay: boolean;
  feedBackReportPopup: boolean;
  isEventShow: boolean;
  showKeyDates: boolean;
  moreDetails: any | null;

  openEditOverlay: () => void;
  closeEditOverlay: () => void;
  markFeedbackPopupVisible: () => void;
  markCalendlyEventShown: (isShown: boolean) => void;
  hideKeyDates: () => void;
  showMoreDetails: (details: any) => void;
  clearMoreDetails: () => void;
}

export const useSuitePageUIState = (): UseSuitePageUIStateReturn => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [feedBackReportPopup, setFeedBackReportPopup] =
    useState<boolean>(false);
  const [isEventShow, setIsEventShow] = useState<boolean>(false);
  const [showKeyDates, setShowKeyDates] = useState<boolean>(true);
  const [moreDetails, setMoreDetails] = useState<any | null>(null);

  const openEditOverlay = (): void => {
    setShowOverlay(true);
  };

  const closeEditOverlay = (): void => {
    setShowOverlay(false);
  };

  const markFeedbackPopupVisible = (): void => {
    setFeedBackReportPopup(true);
  };

  const markCalendlyEventShown = (isShown: boolean): void => {
    setIsEventShow(isShown);
  };

  const hideKeyDates = (): void => {
    setShowKeyDates(false);
  };

  const showMoreDetails = (details: any): void => {
    setMoreDetails(details);
  };

  const clearMoreDetails = (): void => {
    setMoreDetails(null);
  };

  return {
    showOverlay,
    feedBackReportPopup,
    isEventShow,
    showKeyDates,
    moreDetails,

    openEditOverlay,
    closeEditOverlay,
    markFeedbackPopupVisible,
    markCalendlyEventShown,
    hideKeyDates,
    showMoreDetails,
    clearMoreDetails,
  };
};
